import { render, staticRenderFns } from "./dashboard-manufactures.vue?vue&type=template&id=5d3ad67d&scoped=true&"
import script from "./dashboard-manufactures.js?vue&type=script&lang=js&"
export * from "./dashboard-manufactures.js?vue&type=script&lang=js&"
import style0 from "./dashboard-manufactures.scss?vue&type=style&index=0&id=5d3ad67d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ad67d",
  null
  
)

export default component.exports